/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Success_Updatecategorymembers2Inputs */

const en_cases_settings_success_updatecategorymembers2 = /** @type {(inputs: Cases_Settings_Success_Updatecategorymembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category members updated`)
};

/**
* | output |
* | --- |
* | "Category members updated" |
*
* @param {Cases_Settings_Success_Updatecategorymembers2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_success_updatecategorymembers2 = /** @type {((inputs?: Cases_Settings_Success_Updatecategorymembers2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Success_Updatecategorymembers2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_success_updatecategorymembers2(inputs)
});
export { cases_settings_success_updatecategorymembers2 as "cases_settings_success_updateCategoryMembers" }